import { render } from "./DrawerDescriptionHeader.vue?vue&type=template&id=a8c17a92"
import script from "./DrawerDescriptionHeader.vue?vue&type=script&lang=js"
export * from "./DrawerDescriptionHeader.vue?vue&type=script&lang=js"

import "./DrawerDescriptionHeader.vue?vue&type=style&index=0&id=a8c17a92&lang=scss"

import exportComponent from "/builds/lindner/lindner-factorytour-frontend-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__